import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import HealthWellnessForm from './components/HealthWellnessForm';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HealthWellnessForm />
  </React.StrictMode>
); 